module.exports = __webpack_public_path__ + "img/9788959523993.c2ebd71b.jpg";